export default "__VITE_ASSET__DHJ4ffeL__"